import { postRequest } from '@helpers/request'
import { logger } from '@helpers/logger'

export const postEventResult = async (eventResult) => {
  try {
    const { response, logComplete } = await postRequest('eventAdmin/saveEventResult', eventResult)

    logger.log('postEventResult response:', response)

    logComplete()
    return response
  } catch (error) {
    logger.error('postEventResult', error)
    return false
  }
}
